<template>
  <div class="activity-level-filter">
    <UiCheckbox
      v-for="item in checkboxItems"
      :key="item.value"
      :label="item.label"
      :isChecked="item.checked"
      class="activity-level-filter__checkbox"
      @inputValue="toggleValue(item.value)"
    >
      <template #hint>
        {{ item.description }}
      </template>
    </UiCheckbox>
  </div>
</template>

<script setup lang="ts">
  import { watch, ref } from 'vue';
  import { UiCheckbox } from '@experience/core-checkbox-ui';
  import { getActivityLevelFilterItems } from './consts';
  import { type ActivityLevelValue } from '@/shared/types/basic.ts';
  import type { TTourActivityLevel } from '@/entities/filter/store/types/tour/state.ts';

  interface Props {
    filterItems: ActivityLevelValue[];
  }

  const props = defineProps<Props>();
  const emit = defineEmits<{ (e: 'apply', value: TTourActivityLevel): void }>();

  const { MINIMUM, EASY, MEDIUM, HARD } = getActivityLevelFilterItems();

  const activityLevelItemsList = [MINIMUM, EASY, MEDIUM, HARD];

  const checkedValues = ref(new Set(props.filterItems));

  const toggleValue = (value: ActivityLevelValue) => {
    if (checkedValues.value.has(value)) {
      checkedValues.value.delete(value);
    } else {
      checkedValues.value.add(value);
    }
    emit('apply', Array.from(checkedValues.value));
  };

  const checkboxItems = computed(() =>
    activityLevelItemsList.map((item) => ({
      ...item,
      checked: checkedValues.value.has(item.value),
    })),
  );

  watch(
    () => props.filterItems,
    (newVal) => {
      checkedValues.value = new Set(newVal);
    },
  );
</script>

<style scoped lang="scss">
  .activity-level-filter {
    margin-top: 8px;
  }

  .activity-level-filter__checkbox {
    grid-template-columns: 20px 1fr;
    width: 100%;
    margin: 8px 0;
  }
</style>
